/**
 * @group Components
 * 
 * @summary
 * <blockquote>Email input field component for authentication forms.</blockquote>
 * 
 * @example
 * ```tsx
 * <EmailField
 *   control={form.control}
 *   disabled={isPending}
 * />
 * ```
 */

import type { FieldPath, FieldValues } from 'react-hook-form';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '../../forms';
import { Input } from '../../forms/Input';
import type { EmailFieldProps } from './EmailFieldProps';

/**
 * Email input field component
 */
export function EmailField<TFieldValues extends FieldValues = FieldValues>({
  control,
  disabled = false,
  name = 'email' as FieldPath<TFieldValues>,
}: EmailFieldProps<TFieldValues>) {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel>Email</FormLabel>
          <FormControl>
            <Input 
              placeholder="name@example.com" 
              type="email" 
              disabled={disabled}
              {...field} 
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
